import { useEffect } from 'react'


const SelfieFan = ({ selfieFan, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])
    

    return (
        <>
            <div className='SelfieFan__Screen__Selfie__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
                )}
                {/* <img src='/img/page/backgrounds/valentines-day-2026/heart-balloons-background.png' className='SelfieFan__Screen__Selfie__Background__Image' /> */}

                {/* Fondo Lucho Fest */}
                {/* <img src='/img/selfiefan/luchoFest/background-balloons-fancam.png' className='SelfieFan__Screen__Selfie__Background__Balloons' /> */}
            </div>

            <div className='SelfieFan__Screen__Selfie__Box SelfieFan__Screen__Selfie__Up'>
                <div className='SelfieFan__Screen__Selfie__Container'>
                    {selfieFan ? (
                        selfieFan?.source === 'selfie_ia' ? (
                            <>
                                {selfieFan?.image && (
                                    <img src={selfieFan.image} className='SelfieFan__Screen__Selfie__IA__Image' />
                                )}
                                
                                {/* <div className='SelfieFan__Screen__Selfie__Bar'></div> */}

                                <div className={`SelfieFan__Screen__Selfie__Container__Instructions__IA ${!selfieFan.image === 'mx-auto'}`}>
                                    {/* <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ADSL FAN CAM</p> */}
                                    {/* <img src='/img/page/adsl-five.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' /> */}
                                    <img src='/img/selfiefan/IADSL.png' className='SelfieFan__Screen__Selfie__Container__Instructions__IA__Logo' />
                                    {/* <img src='/img/page/qr/selfie-fan-qr-fondo-gris-con-parametros.png' className='SelfieFan__Screen__Selfie__Container__Instructions__IA__QR' /> */}
                                    <img src='/img/page/qr/selfie-fan-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__Selfie__Container__Instructions__IA__QR' />
                                    <p className='SelfieFan__Screen__Selfie__Container__Instructions__IA__Text' style={{ fontFamily: '"GFS Didot", serif', color: '#000' }}>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p>
                                    {/* {selfieFan.caption ? (
                                        <p className='SelfieFan__Screen__Selfie__Container__Instructions__IA__Text' style={{ fontFamily: '"GFS Didot", serif' }}>{selfieFan.caption}</p>
                                    ) : (
                                        <p className='SelfieFan__Screen__Selfie__Container__Instructions__IA__Text' style={{ fontFamily: '"GFS Didot", serif' }}>Vamos con todo equipo</p>
                                    )} */}
                                </div>
                            </>
                        ) : (
                            <>
                                {selfieFan?.image && (
                                    <img src={selfieFan.image} className='SelfieFan__Screen__Selfie__Image' />
                                )}
                                
                                {/* <div className='SelfieFan__Screen__Selfie__Bar'></div> */}

                                <div className={`SelfieFan__Screen__Selfie__Container__Instructions ${!selfieFan.image === 'mx-auto'}`}>
                                    <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' />

                                    {/* Pastel Lucho Fest */}
                                    {/* <img src='/img/selfiefan/luchoFest/birthday-messages-fancam.png' className='SelfieFan__Screen__Selfie__Container__Instructions__BirthdayMessage' /> */}
                                    
                                    <img src='/img/page/qr/selfie-fan-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__Selfie__Container__Instructions__QR' />
                                    {/* <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif', color: '#000', backgroundColor: 'rgba(255,255,255,0.6)' }}>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p> */}
                                    <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text--Small' style={{ fontFamily: '"GFS Didot", serif'}}>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p>
                                    
                                    {/* {selfieFan.caption ? (
                                        <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>{selfieFan.caption}</p>
                                    ) : (
                                        <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>Vamos con todo equipo</p>
                                    )} */}
                                </div>

                                {/* Banderín superior Lucho Fest */}
                                {/* <figure className='SelfieFan__Screen__Selfie__BanderinTop'>
                                    <img src='/img/selfiefan/luchoFest/banderin-top-fancam.png' className='SelfieFan__Screen__Selfie__BanderinTop__Image' />
                                </figure> */}
                            </>
                        )
                    ) : (
                        <div className='SelfieFan__Screen__Selfie__Container__Instructions mx-auto'>
                            {/* <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ADSL FAN CAM</p> */}
                            {/* <img src='/img/page/adsl-five.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' /> */}
                            <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' />
                            <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif'}}>¡VAMOS CON TODO EQUIPO!</p>
                        </div>
                    )}
                </div>
            </div>

            <footer className='SelfieFan__Screen__Selfie__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { SelfieFan };




















//import "https://fonts.googleapis.com/css2?family=GFS+Didot&family=Oswald:wght@200..700&display=swap";
//import "https://fonts.googleapis.com/css2?family=GFS+Didot&family=Oswald:wght@200..700&display=swap";

// <>
//     <div className='SelfieFan__Screen__Background'>
//         <img src='/img/overlay-1.png' className='SelfieFan__Screen__Background__Image' />  
//     </div>

//     <div className='SelfieFan__Screen SelfieFan__Screen__Up Container-FullHeight'>
//         <img src='/img/page/adsl-five.png' className='SelfieFan__Screen__QR__Container__Instructions__Logo' />
//         {selfieFan ? (
//             <>
//                 {selfieFan.image && (
//                     <img src={selfieFan.image} className='SelfieFan__Screen__Image' />
//                 )}
                
//                 {selfieFan.caption ? (
//                     <p className='SelfieFan__Screen__Text'  style={{ fontFamily: '"GFS Didot", serif' }}>{selfieFan.caption}</p>
//                 ) : (
//                     <p className='SelfieFan__Screen__Text'  style={{ fontFamily: '"GFS Didot", serif' }}>¡Vamos con todo equipo!</p>
//                 )}
//             </>
//         ) : (
//             <p className='SelfieFan__Screen__Text'  style={{ fontFamily: '"GFS Didot", serif' }}>¡Vamos con todo equipo!</p>
//         )}
//     </div>

//     <footer className='SelfieFan__Screen__Footer'>Hecho con ♥ por Interaktia | 2026</footer>
// </>

// {selfieFan ? (
//     selfieFan?.source ? (
//         selfieFan.source === 'selfie__fan' ? (

//         ) : (

//         )
//     ) : (

//     )
// ) : (

// )}

// <>
//     <div className='SelfieFan__Screen__Selfie__Background'>
//         {selfieFan.isActiveWomensMode ? (
//             <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//         ) : (
//             <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//         )}
//     </div>

//     <div className='SelfieFan__Screen__Selfie__Box SelfieFan__Screen__Selfie__Up'>
//         <div className='SelfieFan__Screen__Selfie__Container'>
//             {selfieFan ? (
//                 <>
//                     {selfieFan.image && (
//                         <img src={selfieFan.image} className='SelfieFan__Screen__Selfie__Image' />
//                     )}
                    
//                     <div className='SelfieFan__Screen__Selfie__Bar'></div>

//                     <div className={`SelfieFan__Screen__Selfie__Container__Instructions ${!selfieFan.image === 'mx-auto'}`}>
//                         <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ADSL FAN CAM</p>
//                         {/* <img src='/img/page/adsl-five.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' /> */}
//                         <img src='/img/page/adsl-five.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' />
//                         {selfieFan.caption ? (
//                             <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>{selfieFan.caption}</p>
//                         ) : (
//                             <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>Vamos con todo equipo</p>
//                         )}
//                     </div>
//                 </>
//             ) : (
//                 <div className='SelfieFan__Screen__Selfie__Container__Instructions mx-auto'>
//                     <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ADSL FAN CAM</p>
//                     <img src='/img/page/adsl-five.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' />
//                     <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>¡VAMOS CON TODO EQUIPO!</p>
//                 </div>
//             )}
//         </div>
//     </div>

//     <footer className='SelfieFan__Screen__Selfie__Footer'>Hecho con ♥ por Interaktia | 2026</footer>
// </>